import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ColumnTypeIconModule } from '@y42/column-type';
import { FunctionEditorModule } from '@y42/datasource/shared/function-editor';
import { OperationInputModule } from '@y42/datasource/shared/operation-input';
import { DataTestRunErrorDisplayModule } from '../components/data-test-run-error-display/data-test-run-error-display.module';
import { DataTestTypeWithIconModule } from '../components/data-test-type-with-icon/data-test-type-with-icon.module';
import { ColumnTestComponent } from './components/column-test/column-test.component';
import { ErrorThresholdFormPartComponent } from './components/error-threshold-form-part/error-threshold-form-part.component';
import { LowCodeTestComponent } from './components/low-code-test/low-code-test.component';
import { RefIntegrityTestComponent } from './components/ref-integrity-test/ref-integrity-test.component';
import { RowDriftTestComponent } from './components/row-drift-test/row-drift-test.component';
import { SchemaTestComponent } from './components/schema-test/schema-test.component';
import { UniqueTestComponent } from './components/unique-test/unique-test.component';
import { DataTestBuilderComponent } from './data-test-builder.component';

@NgModule({
  exports: [DataTestBuilderComponent],
  declarations: [
    DataTestBuilderComponent,
    SchemaTestComponent,
    RowDriftTestComponent,
    ColumnTestComponent,
    RefIntegrityTestComponent,
    LowCodeTestComponent,
    UniqueTestComponent,
    ErrorThresholdFormPartComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    FontAwesomeModule,
    DataTestTypeWithIconModule,
    ColumnTypeIconModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    DataTestRunErrorDisplayModule,
    FunctionEditorModule,
    MatProgressSpinnerModule,
    OperationInputModule,
  ],
})
export class DataTestBuilderModule {}
